import React from 'react';
import { string, array, func } from 'prop-types';
import { map, size } from 'lodash';
import { Accordion, Text, FlexContainer } from '../../common';
import ChildrenCategory from './ChildrenCategory';

const ParentCategory = ({ id, name, childrens, onClickEdit }) => (
    <Accordion
        title={<Text text={`${id} - ${name}`} size={16} strong />}
        background='#f4f4f4'
        closedBackground='white'
        defaultOpened
    >
        <FlexContainer
            margin={12}
            backgroundColor='#ffffff'
            borderRadius={3}
            padding={16}
            maxWidth={405}
            direction='column'
        >

            { map(childrens, ({ id, name, hall }, index) => (
                <ChildrenCategory
                    key={id}
                    label={`${id} - ${name}`}
                    value={!hall ? '-' : `P ${hall || ''}`}
                    withDivider={size(childrens) - 1 !== index}
                    onClickEdit={() => onClickEdit({ categoryChildrenId: id, hall })}
                />
            ))}
        </FlexContainer>
    </Accordion>
);

ParentCategory.propTypes = {
    id: string,
    name: string,
    childrens: array,
    onClickEdit: func
};

ParentCategory.defaultProps = {
    id: '',
    name: '',
    childrens: [],
    func: () => {}
};

export default ParentCategory;
